import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import PieGraph from "../../../general/PieGraph";
import { GeneralConditionStore } from "./GeneralConditionStore";
import styles from "./GeneralConditionL3.module.css";
import { useEffect, useState } from "react";

function GeneralConditionL3({ distrito, menuFilterParams, searchControl }) {
  const [tipoFossa, setTipoFossa] = useState(null);
  const [descarteLixo, setDescarteLixo] = useState(null);
  const [descarteEsgoto, setDescarteEsgoto] = useState(null);
  const [tipoFossaOldValue, setTipoFossaOldValue] = useState(null);
  const [descarteLixoOldValue, setDescarteLixoOldValue] = useState(null);
  const [descarteEsgotoOldValue, setDescarteEsgotoOldValue] = useState(null);
  const [loading, setLoading] = useState(true);

  const setFossaImage = GeneralConditionStore((state) => state.setFossaImage);
  const setLixoImage = GeneralConditionStore((state) => state.setLixoImage);
  const setEsgotoImage = GeneralConditionStore((state) => state.setEsgotoImage);

  const setFossaValue = GeneralConditionStore((state) => state.setFossaValue);
  const setLixoValue = GeneralConditionStore((state) => state.setLixoValue);
  const setEsgotoValue = GeneralConditionStore((state) => state.setEsgotoValue);

  const fossaValue = GeneralConditionStore((state) => state.fossaValue);
  const lixoValue = GeneralConditionStore((state) => state.lixoValue);
  const esgotoValue = GeneralConditionStore((state) => state.esgotoValue);

  const aguaValue = GeneralConditionStore((state) => state.aguaValue);
  const energiaValue = GeneralConditionStore((state) => state.energiaValue);
  const carroValue = GeneralConditionStore((state) => state.carroValue);

  const { selectedOption, searchInput } = searchControl;
  const { category, subcategoria, natureza } = menuFilterParams;

  const inscricao = Functions.getInscricaoParam(selectedOption, searchInput);
  const proprietario = Functions.getProprietarioParam(
    selectedOption,
    searchInput
  );

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [tipoFossa, descarteLixo, descarteEsgoto] = await Promise.all([
          Api.getTipoFossa(
            distrito,
            category,
            subcategoria,
            natureza,
            inscricao,
            proprietario,
            carroValue,
            energiaValue,
            aguaValue,
            lixoValue,
            esgotoValue
          ),
          Api.getDescarteLixo(
            distrito,
            category,
            subcategoria,
            natureza,
            inscricao,
            proprietario,
            carroValue,
            energiaValue,
            aguaValue,
            fossaValue,
            esgotoValue
          ),
          Api.getDescarteEsgoto(
            distrito,
            category,
            subcategoria,
            natureza,
            inscricao,
            proprietario,
            carroValue,
            energiaValue,
            aguaValue,
            fossaValue,
            lixoValue
          ),
        ]);
        setTipoFossa(Functions.buildPieGraphParams2(tipoFossa));
        setDescarteLixo(Functions.buildPieGraphParams2(descarteLixo));
        setDescarteEsgoto(Functions.buildPieGraphParams2(descarteEsgoto));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroValue,
    energiaValue,
    aguaValue,
    fossaValue,
    lixoValue,
    esgotoValue,
  ]);

  const onTipoFossaClick = (value) => {
    setFossaValue(value);
  };

  const onDescarteLixoClick = (value) => {
    setLixoValue(value);
  };

  const onDescarteEsgotoClick = (value) => {
    setEsgotoValue(value);
  };

  const onTipoFossaOldValue = (value) => {
    setTipoFossaOldValue(value);
  };

  const onDescarteLixoOldValue = (value) => {
    setDescarteLixoOldValue(value);
  };

  const onDescarteEsgotoOldValue = (value) => {
    setDescarteEsgotoOldValue(value);
  };

  if (loading) return <div className={styles.generalConditionL3}></div>;

  return (
    <div className={styles.generalConditionL3}>
      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          <PieGraph
            text="TIPO DE FOSSA"
            data={tipoFossa}
            onLegendClick={onTipoFossaClick}
            onImageReady={setFossaImage}
            currentValue={fossaValue}
            oldValue={tipoFossaOldValue}
            onOldValue={onTipoFossaOldValue}
          />
        </div>
      </div>

      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          <PieGraph
            text="DESCARTE DE LIXO"
            data={descarteLixo}
            onLegendClick={onDescarteLixoClick}
            onImageReady={setLixoImage}
            currentValue={lixoValue}
            oldValue={descarteLixoOldValue}
            onOldValue={onDescarteLixoOldValue}
          />
        </div>
      </div>

      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          <PieGraph
            text="DESCARTE DE ESGOTO"
            data={descarteEsgoto}
            onLegendClick={onDescarteEsgotoClick}
            onImageReady={setEsgotoImage}
            currentValue={esgotoValue}
            oldValue={descarteEsgotoOldValue}
            onOldValue={onDescarteEsgotoOldValue}
          />
        </div>
      </div>
    </div>
  );
}

export default GeneralConditionL3;
